import React from "react";

//ANT DESIGN IMPORTS
import { Input, Row, Typography, Form, Card, Col, Tooltip } from "antd";

//PROJECT IMPORTS
import appLabel from "../../../../../config/appLabel";
import { BOM } from "../../../../../services/definedMethod";

const { Text } = Typography;

export default function TermsForm({ redeDetail }) {
  const [useForm] = Form.useForm();

  return (
    <Form layout="vertical" form={useForm}>
      <Card
        style={{
          marginBottom: "2%",
          boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
          padding: 10,
        }}
      >
        <Row>
          <Col span={8} style={{ padding: "0px 8px" }}>
            <Form.Item label={<Text strong>Is Deposit Mandatory?</Text>}>
              <Input
                className="of-bold-disable-input"
                disabled
                value={redeDetail?.isMandatoryDeposit === true ? "Yes" : "No"}
              />
            </Form.Item>
          </Col>
          <Col span={8} style={{ padding: "0px 8px" }}>
            <Form.Item label={<Text strong>Allow Withdrawals?</Text>}>
              <Input
                className="of-bold-disable-input"
                disabled
                value={redeDetail?.allowWithdrawal === true ? "Yes" : "No"}
              />
            </Form.Item>
          </Col>
          <Col span={8} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <Tooltip title="Adjust advance payments toward future installments">
                  <Text strong>
                    {BOM.SubstringFormat(
                      "Adjust advance payments toward future installments",
                      25
                    )}
                  </Text>
                </Tooltip>
              }
            >
              <Input
                className="of-bold-disable-input"
                disabled
                value={
                  redeDetail?.adjustAdvanceTowardsFuturePayments === true
                    ? "Yes"
                    : "No"
                }
              />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={8} style={{ padding: "0px 8px" }}>
            <Form.Item label={<Text strong>{appLabel.lockInPeriod}</Text>}>
              <Input className="of-bold-disable-input" disabled value={""} />
            </Form.Item>
          </Col>
          <Col span={8} style={{ padding: "0px 8px" }}>
            <Form.Item label={<Text strong>Minimum Deposit Term</Text>}>
              <Input
                className="of-bold-disable-input"
                disabled
                value={`${redeDetail?.minDepositTerm} ${redeDetail?.minDepositTermType?.value}`}
              />
            </Form.Item>
          </Col>
          <Col span={8} style={{ padding: "0px 8px" }}>
            <Form.Item label={<Text strong>Maximum Deposit Term</Text>}>
              <Input
                className="of-bold-disable-input"
                disabled
                value={`${redeDetail?.maxDepositTerm} ${redeDetail?.maxDepositTermType?.value}`}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={8} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={<Text strong>And Thereafter, In Multiples Of</Text>}
              name={"andInMultiplesOf"}
            >
              <Input className="of-bold-disable-input" disabled value={""} />
            </Form.Item>
          </Col>
          <Col span={8} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <Text strong>Apply Penal Interest for Pre-mature Closure?</Text>
              }
            >
              <Input
                className="of-bold-disable-input"
                disabled
                value={
                  redeDetail?.preClosurePenalApplicable === true ? "Yes" : "No"
                }
              />
            </Form.Item>
          </Col>
          <Col span={8} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={<Text strong>Apply Penal Interest (less)</Text>}
              style={{ margin: 0 }}
            >
              <Input
                className="of-bold-disable-input"
                disabled
                value={redeDetail?.preClosurePenalInterest}
              />
            </Form.Item>
          </Col>
          {redeDetail?.preClosurePenalApplicable && (
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item label={<Text strong>Penalty Calculation Method</Text>} style={{ margin: 0 }}>
                <Input
                  className="of-bold-disable-input"
                  disabled
                  value={redeDetail?.preClosurePenalInterestStrategy?.value}
                />
              </Form.Item>
            </Col>
          )}
        </Row>
        <Row>
          <Col span={8} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <Text strong>
                  {appLabel.balanceRequiredForInterestCalculation}
                </Text>
              }
            >
              <Input
                className="of-bold-disable-input"
                disabled
                value={redeDetail?.minBalanceForInterestCalculation}
              />
            </Form.Item>
          </Col>
          <Col span={8} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={<Text strong>{appLabel.iswithholdTaxApplicable}</Text>}
            >
              <Input
                className="of-bold-disable-input"
                disabled
                value={redeDetail?.withHoldTax === false ? "No" : "Yes"}
              />
            </Form.Item>
          </Col>
          <Col span={8} style={{ padding: "0px 8px" }}>
            <Form.Item label={<Text strong>{"Withhold Tax group"}</Text>}>
              <Input
                className="of-bold-disable-input"
                disabled
                value={redeDetail?.taxGroup?.name}
              />
            </Form.Item>
          </Col>
        </Row>
      </Card>
    </Form>
  );
}
